import React, { Component } from 'react'
import Link from 'gatsby-link'

import './link-box.css'

class LinkBox extends Component {

  render () {
    let data = this.props.data;

    let style = this.props.fixedWidth ? {width : this.props.fixedWidth} : {};

    return (
      <div style={{textAlign: 'center'}}>
        <a style={style} className="link-box" href={data.href} target="_blank">
          {data.text}
        </a>
      </div>
    );
  }
}


export default {LinkBox}



// WEBPACK FOOTER //
// ./src/components/LinkBox/index.js